import { useTranslation } from 'react-i18next';
import { useOneTimeReportStore } from '../../store';
import style from '@Report/OneTimeReports/index.module.less';
import { Textarea, TextLabel } from '@tonic-one/react';
import { useEffect } from 'react';

const ReportDesc = () => {
  const { t } = useTranslation();
  //getter
  const desc = useOneTimeReportStore((store) => store.generalSetting.desc);

  //setter
  const setDesc = useOneTimeReportStore((store) => store.setDesc);

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );
  useEffect(() => {
    const cb = () => setDesc('');
    register(cb);
    return () => unregister(cb);
  }, []);
  return (
    <>
      <TextLabel className={style.itemLabel}>
        {t('reportCommon.labels.description')}:
      </TextLabel>
      <Textarea
        mt="1x"
        maxLength={2048}
        rows={3}
        placeholder={t('reportCommon.placeholders.description')}
        value={desc}
        onChange={(e: any) => setDesc(e.target.value)}
        width={450}
      />
    </>
  );
};

export default ReportDesc;
